module.exports = __webpack_public_path__ + "static/ch5-SCENE-08-MLK_Calls_Activists_To_Come_To_Selma-944a8107086bd5fbda19f96c930235a5.mp4";